import { clsx } from "clsx";

export function RadioGroup<T extends string>({ value, options, onChange }: { value: T; options: { value: T; label: string; className?: string }[]; onChange: (value: T) => void }) {
  return (
    <div className="grid grid-cols-3 gap-2">
      {options.map((option) => (
        <button
          key={option.value}
          className={clsx("h-9 rounded-md border text-sm font-medium transition", value === option.value ? "border-brand-500 bg-brand-50 text-brand-700 dark:bg-brand-500/15 dark:text-brand-200" : "border-border bg-card text-muted hover:bg-hover dark:border-border-dark dark:bg-card-dark", option.className)}
          onClick={() => onChange(option.value)}
          type="button"
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
